import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=7c343cba&scoped=true"
import script from "./mail.vue?vue&type=script&lang=ts"
export * from "./mail.vue?vue&type=script&lang=ts"
import style0 from "./mail.vue?vue&type=style&index=0&id=7c343cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c343cba",
  null
  
)

export default component.exports